import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useFormContext } from '../context/FormContext';
import Header from '../components/Header';
import Footer from '../components/Footer';
import CTAButton from '../components/CTAButton';
import SecurityBadges from '../components/SecurityBadges';

const PersonalData: React.FC = () => {
  const { formData, updateFormData, nextStep } = useFormContext();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<{
    gender?: string;
    firstName?: string;
    lastName?: string;
  }>({});
  const [isSubmitting, setIsSubmitting] = useState(false);

  const validateForm = () => {
    const newErrors: {
      gender?: string;
      firstName?: string;
      lastName?: string;
    } = {};
    
    if (!formData.gender) {
      newErrors.gender = 'Bitte wählen Sie das Geschlecht aus';
    }
    
    if (!formData.firstName.trim()) {
      newErrors.firstName = 'Bitte geben Sie den Vornamen ein';
    }
    
    if (!formData.lastName.trim()) {
      newErrors.lastName = 'Bitte geben Sie den Nachnamen ein';
    }
    
    setErrors(newErrors);
    return Object.keys(newErrors).length === 0;
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (validateForm()) {
      setIsSubmitting(true);
      
      try {
        await nextStep({
          gender: formData.gender,
          firstName: formData.firstName,
          lastName: formData.lastName
        });
        navigate('/address-data');
      } catch (error) {
        console.error('Error submitting form:', error);
      } finally {
        setIsSubmitting(false);
      }
    }
  };

  return (
    <div className="min-h-screen flex flex-col">
      <Header />
      
      <main className="flex-grow container mx-auto px-4 py-8 max-w-3xl">
        <div className="form-container fade-in">
          <h2 className="text-2xl text-center font-semibold text-deep-blue mb-8">
            Persönliche Daten der gesuchten Person:
          </h2>
          
          <form onSubmit={handleSubmit} className="space-y-6">
            <div>
              <label htmlFor="gender" className="block text-sm font-medium text-gray-700 mb-1">
                Geschlecht:
              </label>
              <select
                id="gender"
                className="select-field"
                value={formData.gender}
                onChange={(e) => updateFormData('gender', e.target.value)}
              >
                <option value="">Bitte auswählen</option>
                <option value="male">Männlich</option>
                <option value="female">Weiblich</option>
                <option value="none">Keine Angabe</option>
              </select>
              {errors.gender && <p className="mt-1 text-sm text-red-600">{errors.gender}</p>}
            </div>
            
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
              <div>
                <label htmlFor="firstName" className="block text-sm font-medium text-gray-700 mb-1">
                  Vorname:
                </label>
                <input
                  type="text"
                  id="firstName"
                  placeholder="Erika"
                  className="input-field"
                  value={formData.firstName}
                  onChange={(e) => updateFormData('firstName', e.target.value)}
                />
                {errors.firstName && <p className="mt-1 text-sm text-red-600">{errors.firstName}</p>}
              </div>
              
              <div>
                <label htmlFor="lastName" className="block text-sm font-medium text-gray-700 mb-1">
                  Nachname:
                </label>
                <input
                  type="text"
                  id="lastName"
                  placeholder="Mustermann"
                  className="input-field"
                  value={formData.lastName}
                  onChange={(e) => updateFormData('lastName', e.target.value)}
                />
                {errors.lastName && <p className="mt-1 text-sm text-red-600">{errors.lastName}</p>}
              </div>
            </div>
            
            <div className="mt-8 flex justify-center">
              <CTAButton 
                type="submit" 
                text="Weiter"
                arrow={true}
                className={`w-full md:w-auto ${isSubmitting ? 'opacity-70 cursor-not-allowed' : ''}`}
              />
            </div>
          </form>
        </div>
        
        <SecurityBadges />
      </main>
      
      <Footer />
    </div>
  );
};

export default PersonalData;
